import React from "react";

import theme, { roundness } from "../../../utils/styles";

import Fade from "react-reveal/Fade";

const Card = (props) => {
  const { index, data, hover, hoverIndex, revealDirection, isBreakpoint } =
    props;
  const { name, image, text, link } = data;

  const hoverData = {
    hover,
    index,
    hoverIndex,
  };

  return (
    <Fade
      right={revealDirection === "right"}
      left={revealDirection === "left"}
      duration={400}
      opposite
      distance={isBreakpoint ? "0px" : "70px"}
    >
      <div style={styles(hoverData).bg}>
        <div style={styles(hoverData).root}>
          <img src={image} alt={name} style={styles(hoverData).image}></img>
          <div style={styles(hoverData).title}>{name}</div>
          <div style={styles(hoverData).text}>{text}</div>
          <a
            href={link}
            target="_blank"
            rel="noreferrer"
            style={styles(hoverData).link}
          >
            Learn More
          </a>
        </div>
      </div>
    </Fade>
  );
};

export default Card;

const styles = (hoverData) => {
  const { hover, hoverIndex, index } = hoverData;

  const height = 420;
  const width = 330;
  const transition = "ease-in-out 0.5s";
  const transitionFaster = "ease-in-out 0.2s";
  const textHorizontalMargin = 15;

  return {
    bg: {
      background:
        hover && hoverIndex === index ? "white" : theme.colors.background,
      borderWidth: hover && hoverIndex === index ? 3 : 0,
      borderRadius: roundness.card,
      borderStyle: "solid",
      borderColor: "#ffffff00",
      transition: transitionFaster,
      height,
      width,
      opacity: 1,
    },
    root: {
      background: "white",
      borderRadius: roundness.card,
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-start",
      flexDirection: "column",
      rowGap: textHorizontalMargin,
      transition,
      opacity: hover && hoverIndex !== index ? 0.3 : 1,
      height: "100%",
    },
    image: {
      borderStyle: "solid",
      borderColor: "white",
      borderTopLeftRadius: roundness.card,
      borderTopRightRadius: roundness.card,
      borderWidth: 4,
      width: width - 4 * 2,
    },
    title: {
      fontWeight: "bold",
      fontSize: "16px",
      color: theme.colors.background,
      borderStyle: "solid none none none",
      borderWidth: "2px",
      borderColor: theme.colors.background,
      width: "80%",
      lineHeight: 2.5,
    },
    text: {
      fontSize: "12px",
      color: theme.colors.gray1,
      lineHeight: 1.5,
      width: "80%",
    },
    link: {
      display: hover && hoverIndex === index ? "block" : "none",
      fontSize: "12px",
      fontWeight: "bold",
      color: theme.colors.primary,
      textDecoration: "none",
      cursor: "pointer",
      width: "80%",
    },
  };
};
